module.exports = __webpack_public_path__ + "media/images/sp_navBg-deb43773807dd4220df7b904d4e4ae63.webp";